import { NotificationType, notify } from 'src/providers/NotificationProvider'

import { ButtonRebrand } from 'src/components/atoms/ButtonRebrand'
import { Heading3, Heading5, Paragraph } from 'src/components/atoms/Typography'
import { HStack } from 'src/components/templates/HStack'

import {
  namedOperations,
  useUpdateGiftTemplateMutation
} from 'src/config/generated/graphql'

export interface ArchiveGiftTemplateModalProps {
  id?: string
  title?: string
  closeModal: () => void
}

export const ArchiveGiftTemplateModal = ({
  id,
  title,
  closeModal
}: ArchiveGiftTemplateModalProps) => {
  const [updateGiftTemplate] = useUpdateGiftTemplateMutation({
    refetchQueries: [namedOperations.Query.listAdminGiftTemplates]
  })

  const handleArchive = async () => {
    if (!id) return

    try {
      await updateGiftTemplate({
        variables: { input: { Id: id, IsAvailable: false } }
      })
      notify({
        message: 'Certificate archived',
        type: NotificationType.success
      })
      closeModal()
    } catch {
      notify({
        message: 'Could not archive the certificate',
        type: NotificationType.error
      })
    }
  }

  return (
    <div className='w-full sm:w-[520px]'>
      <Heading3>Archive certificate</Heading3>
      {title ? <Heading5>{title}</Heading5> : null}
      <Paragraph>
        Are you sure you want to archive this certificate? It will no longer be
        available to select for bulk gifts.
      </Paragraph>
      <HStack className='mt-10 flex justify-between'>
        <ButtonRebrand variant='outline' onClick={closeModal}>
          Cancel
        </ButtonRebrand>
        <ButtonRebrand variant='lime' onClick={handleArchive}>
          Yes, archive
        </ButtonRebrand>
      </HStack>
    </div>
  )
}
